var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-borderline",class:{
    'b-borderline--large': _vm.large,
    'b-borderline--tiny': _vm.tiny,
  }},[_c('v-sheet',{staticClass:"b-borderline__line",style:({ height: _vm.height }),attrs:{"tile":"","color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }